<template>
    <search-summary-layout
        :search-disabled="searchDisabled"
        :form-component="searchFormComponent"
        :search-request="searchRequest"
        tourists-label="guest"
        show-dates
        show-nights
        show-tourists
    >
        <template v-slot:title>
            {{ locationLabel }}
        </template>
    </search-summary-layout>
</template>

<script lang="ts">
    import {Component, Prop, Vue, Watch} from 'vue-facing-decorator'
    import HotelSearchForm from '~/components/search/forms/HotelSearchForm.vue'
    import SearchSummaryLayout from '~src/components/parts/searchSummaryLayout.src'

    //TODO Hide if empty searchRequest
    @Component({
        components: {
            HotelSearchForm,
            SearchSummaryLayout,
        },
    })
    export class HotelSearchSummary extends Vue {
        @Prop({default: false, type: Boolean}) searchDisabled
        @Prop({required: true}) searchRequest

        searchForm = false

        @Watch('isSearchActive')
        onLoadingChange(searchActive) {
            if (searchActive) {
                this.searchForm = false
            }
        }

        get searchFormComponent() {
            return resolveComponent('HotelSearchForm')
        }

        get isSearchActive() {
            return hotelsRuntimeStore.searchActive
        }

        get locationLabel() {
            if (this.$conf.public.searchWithoutDestination) return hotelsRuntimeStore.country.name

            return `${hotelsRuntimeStore.city.name}, ${hotelsRuntimeStore.city.countryName}`
        }
    }

    export default HotelSearchSummary
</script>
